// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header .header {
  display: flex;
  height: var(--header-height);
  position: fixed;
  top: 0;
  width: 100%;
  align-items: center;
  box-sizing: border-box;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2509803922);
  z-index: 25;
}
header .header.super-admin-mode {
  background: linear-gradient(90deg, rgb(173, 73, 73) 10%, rgb(194, 190, 70) 24%, rgb(117, 177, 110) 39%, rgb(91, 175, 184) 54%, rgb(100, 94, 175) 71%, rgb(184, 105, 173) 86%, rgb(185, 71, 72) 100%);
}
header .header p {
  margin-bottom: 0px;
}
header .header .header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-right: var(--page-padding);
  padding-left: var(--element-spacing);
}
header .header .header-content.editor-mode {
  padding-right: var(--element-spacing);
}
header .header .header-content .tour-link {
  cursor: pointer;
}
header .header .creator-logo,
header .header .profile {
  display: flex;
  align-items: center;
}
header .header .small-text {
  font-size: 13px;
}
header .header a.dashboard-button {
  display: flex;
  height: 100%;
}
header .header a.dashboard-button:hover svg {
  transform: scale(1.08);
}
header .header a.dashboard-button button {
  cursor: pointer;
  width: var(--header-height);
  background-color: var(--primary-color);
  border: none;
  height: 100%;
}
header .header a.dashboard-button button svg-icon {
  font-size: 40px;
}
header .header a.dashboard-button button svg-icon span {
  display: flex;
  flex-direction: column;
  align-items: center;
}
header .header a.dashboard-button button svg-icon svg {
  transition: 0.2s transform;
}
header .header .creator-logo img {
  cursor: pointer;
  height: 15px;
  transition: 0.2s transform;
}
header .header .creator-logo img:hover {
  transform: scale(1.08);
}
header .header .super-admin-settings {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  margin-right: var(--large-spacing);
  cursor: pointer;
}
header .header .super-admin-settings .svg-icon {
  display: flex;
  font-size: 30px;
  margin-left: var(--small-spacing);
}
header .header .profile-container {
  display: flex;
}
header .header .profile-container .profile {
  overflow: hidden;
  cursor: pointer;
}
header .header .profile-container .profile p {
  max-height: 33px;
  margin: 0;
  margin-right: var(--motes-padding);
  overflow: hidden;
  text-overflow: ellipsis;
}
header .header .profile-container .profile picture {
  height: 40px;
}
header .header .profile-container .profile img {
  width: 40px;
  border-radius: 50%;
  height: 100%;
  cursor: pointer;
}
header .header .tour-info {
  display: flex;
  justify-content: flex-start;
}
header .header .tour-info > span {
  display: flex;
  align-items: center;
  margin-right: var(--element-spacing);
}
header .header .tour-info > span svg-icon {
  margin-right: 5px;
}
header .header .tour-actions {
  display: flex;
  align-items: center;
  margin-left: auto;
}
header .header .tour-actions > p {
  display: flex;
  align-items: center;
  margin-right: var(--motes-padding);
}
header .header .tour-actions > p svg-icon {
  margin-right: 5px;
}
header .header .tour-actions > div > button {
  margin-left: var(--motes-padding);
}
header .header .tour-actions .dropdown-wrapper {
  position: relative;
  display: flex;
  justify-content: flex-end;
}
header .header .tour-actions .dropdown {
  position: absolute;
  width: 300px;
  background-color: #333333;
  padding: var(--motes-padding);
  border-radius: 10px;
}
header .header .tour-actions .dropdown .inner-dropdown {
  position: relative;
  padding: var(--motes-padding);
  background-color: #555555;
  border-radius: 10px;
}
header .header .tour-actions .dropdown .inner-dropdown button {
  margin-bottom: 0;
}
header .header .overlay-container {
  max-width: 50vw;
}
header .header .overlay-container h3 {
  text-align: center;
}
header .header .overlay-container .qr-code-container {
  display: flex;
  justify-content: center;
}
header .header .overlay-container .qr-code {
  border: 1px solid black;
}
header .header .publish-tour-popup h4 {
  margin-bottom: 8px;
}
header .header .admin-toggle {
  position: absolute;
  width: 20px;
  top: 0;
  right: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
header .header .admin-toggle .toggle {
  width: 10px;
  height: 40px;
}
header .header .admin-toggle .toggle .switch {
  top: 2px;
  left: 1px;
  width: 8px;
  height: 8px;
}
header .header .admin-toggle .toggle.checked .switch {
  transform: translateY(28px);
}
header .spacer {
  height: var(--header-height);
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,4BAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,mDAAA;EACA,WAAA;AAAR;AAEQ;EACI,oMAAA;AAAZ;AAGQ;EACI,kBAAA;AADZ;AAIQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,oCAAA;AAFZ;AAIY;EACI,qCAAA;AAFhB;AAIY;EACI,eAAA;AAFhB;AAMQ;;EAEI,aAAA;EACA,mBAAA;AAJZ;AAOQ;EACI,eAAA;AALZ;AAQQ;EACI,aAAA;EACA,YAAA;AANZ;AAUgB;EACI,sBAAA;AARpB;AAYY;EACI,eAAA;EACA,2BAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;AAVhB;AAYgB;EACI,eAAA;AAVpB;AAYoB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAVxB;AAaoB;EACI,0BAAA;AAXxB;AAiBQ;EACI,eAAA;EACA,YAAA;EACA,0BAAA;AAfZ;AAiBY;EACI,sBAAA;AAfhB;AAqBQ;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kCAAA;EACA,eAAA;AAnBZ;AAqBY;EACI,aAAA;EACA,eAAA;EACA,iCAAA;AAnBhB;AAuBQ;EACI,aAAA;AArBZ;AAuBY;EACI,gBAAA;EACA,eAAA;AArBhB;AAuBgB;EACI,gBAAA;EACA,SAAA;EACA,kCAAA;EACA,gBAAA;EACA,uBAAA;AArBpB;AAwBgB;EACI,YAAA;AAtBpB;AAyBgB;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAvBpB;AA4BQ;EACI,aAAA;EACA,2BAAA;AA1BZ;AA4BY;EACI,aAAA;EACA,mBAAA;EACA,oCAAA;AA1BhB;AA4BgB;EACI,iBAAA;AA1BpB;AA+BQ;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AA7BZ;AA+BY;EACI,aAAA;EACA,mBAAA;EACA,kCAAA;AA7BhB;AA+BgB;EACI,iBAAA;AA7BpB;AAiCY;EACI,iCAAA;AA/BhB;AAkCY;EACI,kBAAA;EACA,aAAA;EACA,yBAAA;AAhChB;AAmCY;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;AAjChB;AAmCgB;EACI,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;AAjCpB;AAmCoB;EACI,gBAAA;AAjCxB;AAwCQ;EACI,eAAA;AAtCZ;AAwCY;EACI,kBAAA;AAtChB;AAyCY;EACI,aAAA;EACA,uBAAA;AAvChB;AA2CY;EACI,uBAAA;AAzChB;AA8CY;EACI,kBAAA;AA5ChB;AAgDQ;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA9CZ;AAgDY;EACI,WAAA;EACA,YAAA;AA9ChB;AAgDgB;EACI,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AA9CpB;AAiDgB;EACI,2BAAA;AA/CpB;AAqDI;EACI,4BAAA;AAnDR","sourcesContent":["header {\n    .header {\n        display: flex;\n        height: var(--header-height);\n        position: fixed;\n        top: 0;\n        width: 100%;\n        align-items: center;\n        box-sizing: border-box;\n        box-shadow: 0px 2px 6px #00000040;\n        z-index: 25; // Root-level navigation elements should have z-indices ranging between 20 and 29\n\n        &.super-admin-mode {\n            background: linear-gradient(90deg, rgba(173,73,73,1) 10%, rgba(194,190,70,1) 24%, rgba(117,177,110,1) 39%, rgba(91,175,184,1) 54%, rgba(100,94,175,1) 71%, rgba(184,105,173,1) 86%, rgba(185,71,72,1) 100%);\n        }\n\n        p {\n            margin-bottom: 0px;\n        }\n\n        .header-content {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            width: 100%;\n            height: 100%;\n            padding-right: var(--page-padding);\n            padding-left: var(--element-spacing);\n\n            &.editor-mode {\n                padding-right: var(--element-spacing);\n            }\n            .tour-link {\n                cursor: pointer;\n            }\n        }\n\n        .creator-logo,\n        .profile {\n            display: flex;\n            align-items: center;\n        }\n\n        .small-text {\n            font-size: 13px;\n        }\n\n        a.dashboard-button {\n            display: flex;\n            height: 100%;\n\n            &:hover {\n\n                svg {\n                    transform: scale(1.08);\n                }\n            }\n\n            button {\n                cursor: pointer;\n                width: var(--header-height);\n                background-color: var(--primary-color);\n                border: none;\n                height: 100%;\n\n                svg-icon {\n                    font-size: 40px;\n\n                    span {\n                        display: flex;\n                        flex-direction: column;\n                        align-items: center;\n                    }\n\n                    svg {\n                        transition: 0.2s transform;\n                    }\n                }\n            }\n        }\n\n        .creator-logo img {\n            cursor: pointer;\n            height: 15px;\n            transition: 0.2s transform;\n\n            &:hover {\n                transform: scale(1.08);\n            }\n\n\n        }\n\n        .super-admin-settings {\n            display: flex;\n            align-items: center;\n            justify-content: flex-end;\n            margin-left: auto;\n            margin-right: var(--large-spacing);\n            cursor: pointer;\n\n            .svg-icon {\n                display: flex;\n                font-size: 30px;\n                margin-left: var(--small-spacing);\n            }\n        }\n\n        .profile-container {\n            display: flex;\n\n            .profile {\n                overflow: hidden;\n                cursor: pointer;\n\n                p {\n                    max-height: 33px;\n                    margin: 0;\n                    margin-right: var(--motes-padding);\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                }\n\n                picture {\n                    height: 40px;\n                }\n\n                img {\n                    width: 40px;\n                    border-radius: 50%;\n                    height: 100%;\n                    cursor: pointer;\n                }\n            }\n        }\n\n        .tour-info {\n            display: flex;\n            justify-content: flex-start;\n\n            >span {\n                display: flex;\n                align-items: center;\n                margin-right: var(--element-spacing);\n\n                svg-icon {\n                    margin-right: 5px;\n                }\n            }\n        }\n\n        .tour-actions {\n            display: flex;\n            align-items: center;\n            margin-left: auto;\n\n            >p {\n                display: flex;\n                align-items: center;\n                margin-right: var(--motes-padding);\n\n                svg-icon {\n                    margin-right: 5px;\n                }\n            }\n\n            >div>button {\n                margin-left: var(--motes-padding);\n            }\n\n            .dropdown-wrapper {\n                position: relative;\n                display: flex;\n                justify-content: flex-end;\n            }\n\n            .dropdown {\n                position: absolute;\n                width: 300px;\n                background-color: #333333;\n                padding: var(--motes-padding);\n                border-radius: 10px;\n\n                .inner-dropdown {\n                    position: relative;\n                    padding: var(--motes-padding);\n                    background-color: #555555;\n                    border-radius: 10px;\n\n                    button {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n\n        }\n\n        .overlay-container {\n            max-width: 50vw;\n\n            h3 {\n                text-align: center;\n            }\n\n            .qr-code-container {\n                display: flex;\n                justify-content: center;\n            }\n\n\n            .qr-code {\n                border: 1px solid black;\n            }\n        }\n\n        .publish-tour-popup {\n            h4 {\n                margin-bottom: 8px;\n            }\n        }\n\n        .admin-toggle {\n            position: absolute;\n            width: 20px;\n            top: 0;\n            right: 0;\n            height: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            .toggle {\n                width: 10px;\n                height: 40px;\n\n                .switch {\n                    top: 2px;\n                    left: 1px;\n                    width: 8px;\n                    height: 8px;\n                }\n\n                &.checked .switch {\n                    transform: translateY(28px);\n                }\n            }\n        }\n    }\n\n    .spacer {\n        height: var(--header-height);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
